import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { formatPrice } from 'common/helpers'

import CircleLoader from 'components/loaders/CircleLoader/CircleLoader'
import CheckBox from 'components/forms/CheckBox/CheckBox'
import Text from 'components/_new/typography/Text/Text'
import Box from 'components/_new/layout/Box/Box'
import Price from 'components/text/Price/Price'

import messages from './messages'
import s from './Credits.scss'


class Credits extends PureComponent {

  static propTypes = {
    creditBalance: PropTypes.number.isRequired,
    useCredits: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    creditValue: PropTypes.number,
  }

  handleChange = () => {
    const { useCredits } = this.props

    actions.view.paymentPage.toggleUseCredits(!useCredits)
  }

  render() {
    const { isFetching, creditValue, creditBalance, useCredits } = this.props

    return (
      <Box mt="16" className={s.credits} id="billCreditsRow">
        <Text
          message={messages.creditBalance}
          values={{ balance: formatPrice(creditBalance, true) }}
        />
        {
          isFetching ? (
            <CircleLoader />
          ) : (
            <div>
              <Price value={creditValue} isCents />
              <CheckBox
                className={s.creditsCheckbox}
                id="useCredits"
                brand
                checked={useCredits}
                onChange={this.handleChange}
              />
            </div>
          )
        }
      </Box>
    )
  }
}


export default Credits
